import { render } from "./typeCastingComponent.vue?vue&type=template&id=02c96226&scoped=true"
import script from "./typeCastingComponent.vue?vue&type=script&lang=js"
export * from "./typeCastingComponent.vue?vue&type=script&lang=js"

import "./typeCastingComponent.vue?vue&type=style&index=0&id=02c96226&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c96226"]])

export default __exports__